<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOn_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15.75 12.625a3.75 3.75 0 0 1-7.5 0v-6.25a3.75 3.75 0 0 1 7.5 0v6.25Zm1.25-1.25a.625.625 0 0 1 1.25 0v1.25c0 3.232-2.476 5.868-5.625 6.187v2.563a.625.625 0 0 1-1.25 0v-2.563c-3.149-.319-5.625-2.955-5.625-6.187v-1.25a.625.625 0 0 1 1.25 0v1.25c0 2.758 2.243 5 5 5s5-2.242 5-5v-1.25Z"
        clip-rule="evenodd"
    />
</svg>
